"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigClient = void 0;
const js_config_common_1 = require("@atlassian/js-config-common");
class ConfigClient {
    static async fetch(options) {
        var _a;
        const fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: "POST",
            body: JSON.stringify(options.context),
            headers: {
                "content-type": "application/json",
                "x-api-key": options.ffsApiKey,
            },
        });
        if (!response.ok) {
            throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        }
        const valuesPayload = await response.text();
        return js_config_common_1.ConfigCollection.fromValues(valuesPayload);
    }
}
exports.ConfigClient = ConfigClient;
